module.exports = __webpack_public_path__ + "files/1740007c7ef0f11c3045063769fbf621.png";